import request from '@/router/axios'
import env from '@/config/env'

// 查询接送订单
export const postForderViewApi = (data) => {
  return request({
    url: env.ferryUrl + '/forder/view-all',
    method: 'POST',
    data
  })
}
// 查询接送订单
export const controlsMap = (data) => {
  return request({
    url: env.ferryUrl + '/forder/makeandsplitpoolingorder',
    method: 'POST',
    data
  })
}
